const Ext = require('ext')
const CompanyNewPanel = require('admin/view/CompanyNewPanel')

const DistributorNewPanel = Ext.define(null, {
  extend: CompanyNewPanel,

  module() {
    return require('admin/business/DistributorResource')
  }
})

module.exports = DistributorNewPanel
